import { render, staticRenderFns } from "./AddressVerification.vue?vue&type=template&id=43808017&"
import script from "./AddressVerification.vue?vue&type=script&lang=js&"
export * from "./AddressVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports